import script from "./indexpage.vue?vue&type=script&setup=true&lang=js"
export * from "./indexpage.vue?vue&type=script&setup=true&lang=js"

import "./indexpage.vue?vue&type=style&index=0&id=3ecd8d06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ecd8d06"]])

export default __exports__